module.exports = __webpack_public_path__ + "static/media/grena.183de87b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gifts/grena.png
// module id = 47
// module chunks = 0